import React from 'react'
import { useNavigate } from 'react-router-dom'
import { DropdownMenu } from 'components/ds'
import type { Track } from 'types/track'

type Props = {
  closeMenu: () => void
  track: Track
}

const LyricTranscription = ({ track }: Props): React.ReactNode => {
  const navigate = useNavigate()
  return (
    <DropdownMenu.Item
      onSelect={() =>
        navigate({
          pathname: `/explorer/tracks/${track.id}/edit-metadata/`,
          search: '?tab=1',
        })
      }
    >
      Lyric transcription
    </DropdownMenu.Item>
  )
}

export default LyricTranscription
